import * as ActionTypes from '../constants/actionTypes'
import { sellersSimpleList } from '../api/seller'

export const fetchItems = (params = {}) => (dispatch) => {
  dispatch({ type: ActionTypes.SELLERS_FETCHITEMS_LOAD })

  sellersSimpleList(params).then((res) => {
    const items = res.result

    const mockData = []
    items.map((item) => {
      mockData.push({
        key: item.idnum,
        title: item.s_name,
      })
    })

    dispatch({
      type: ActionTypes.SELLERS_FETCHITEMS_SUCCEED,
      items: mockData,
    })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.SELLERS_FETCHITEMS_FAIL,
      fetchSellersError: 'Ошибка получения торговых сетей',
    })
  })
}



// WEBPACK FOOTER //
// src/actions/sellers.js